import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isNativePlatform } from './platformService.js';

export async function tapHaptic() {
  if (!isNativePlatform()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    // Haptics are optional polish; never block navigation on them.
  }
}
